import React from "react";

const CustomButton = ({
  children,
  onClick,
  type = "button",
  variant = "solid",
  size = "medium",
  iconLeft = null,
  iconRight = null,
  loading = false,
  disabled = false,
  gradientOutline = false,
  className = "",
  ...props
}) => {
  const baseClasses = "rounded-md font-medium focus:outline-none";
  let buttonClasses = "";

  // Handle different button variants
  switch (variant) {
    case "solid":
      buttonClasses = "bg-blue-500 text-white hover:bg-blue-600";
      break;
    case "ghost":
      buttonClasses = "border border-blue-500 text-blue-500 hover:bg-blue-50";
      break;
    default:
      buttonClasses = "bg-blue-500 text-white hover:bg-blue-600";
      break;
  }

  // Handle different button sizes
  switch (size) {
    case "small":
      buttonClasses += " px-2 py-1 text-sm";
      break;
    case "large":
      buttonClasses += " px-4 py-2 text-lg";
      break;
    default:
      buttonClasses += " px-3 py-2 text-base";
      break;
  }

  // Add gradient outline
  if (gradientOutline) {
    buttonClasses += " border-2 border-gradient";
  }

  // Add disabled styles
  if (disabled || loading) {
    buttonClasses += " opacity-50 cursor-not-allowed";
  }

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={`${baseClasses} ${buttonClasses} ${className}`}
      {...props}
    >
      {loading ? (
        <span className="flex items-center justify-center">
          <svg className="animate-spin h-5 w-5 mr-3" viewBox="0 0 24 24">
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.373A8 8 0 0112 4.597v4.324A3.998 3.998 0 008 12H6v5.373z"
            ></path>
          </svg>
          Processing...
        </span>
      ) : (
        <>
          {iconLeft && !loading && <span className="mr-2">{iconLeft}</span>}
          {children}
          {iconRight && !loading && <span className="ml-2">{iconRight}</span>}
        </>
      )}
    </button>
  );
};

export default CustomButton;
